import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import SystemOverview from './pages/system-overview';
import ServerDetail from './pages/server-detail';
import CampaignManager from './pages/campaign-manager';
import WarRoomDashboard from './pages/war-room-dashboard';
import RiskAwareCampaignCreator from './pages/risk-aware-campaign-creator';
import ServerAutopsy from '../pages/server-autopsy';
import DataIntelligenceHub from './pages/data-intelligence-hub';
import ContactListsManagement from './pages/contact-lists-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<SystemOverview />} />
        <Route path="/system-overview" element={<SystemOverview />} />
        <Route path="/server-detail" element={<ServerDetail />} />
        <Route path="/server-autopsy" element={<ServerAutopsy />} />
        <Route path="/campaign-manager" element={<CampaignManager />} />
        <Route path="/war-room-dashboard" element={<WarRoomDashboard />} />
        <Route path="/risk-aware-campaign-creator" element={<RiskAwareCampaignCreator />} />
        <Route path="/data-intelligence-hub" element={<DataIntelligenceHub />} />
        <Route path="/contact-lists-management" element={<ContactListsManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
